import ExportForm from "../common/ExportForm";
import { ASSIGNMENT_EXPORT_COLUMNS } from "./actions_loaders";

export default function AssignmentExport() {
    return <ExportForm columns={ASSIGNMENT_EXPORT_COLUMNS} />;
}
